import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import cx from 'clsx';
import styles from './styles.module.css';

export interface StepProps extends ComponentPropsWithoutRef<'li'> {
  title: string;
  subtitle?: string;
}

export function Step({ title, subtitle, className = '', ...props }: StepProps): ReactNode {
  return (
    <li className={cx('mb-24', styles.step, className)} {...props}>
      <span className={styles.bubble} />
      <span>
        <h2 className={styles['step-title']} data-test-step-title>
          {title}
        </h2>
        {subtitle ? (
          <p className={styles['step-subtitle']} data-test-step-subtitle>
            {subtitle}
          </p>
        ) : null}
      </span>
    </li>
  );
}
